export const fonts = {
  primary: 'BurbankBigRegular-Black, sans-serif',
};
